import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getCards } from './actions'
import { Cards } from './components/Cards/Cards'

export class CardTrashed extends Component {
  static propTypes = {}
  componentDidMount(){
    this.props.getCards()
  }

  render() {
    const {cards} = this.props;
    console.log("🚀 ~ file: CardTrashed.jsx ~ line 11 ~ CardTrashed ~ render ~ props", cards)
    return (
      <div className="qbm-content">
        <Cards cards={cards}/>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  cards: state.card.list_trashed,
})

const mapDispatchToProps = {
  getCards,
}

export default connect(mapStateToProps, mapDispatchToProps)(CardTrashed)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/CardTrashed/CardTrashed.jsx